module.exports = __webpack_public_path__ + "images/tour/lists.6f98a47f3dee1c858114.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tour/lists.svg
// module id = iPME
// module chunks = 13